import { useTranslation } from "react-i18next";
import { useObjectCard } from "../context/ObjectCardProvider";
import { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import spinnerTitle from "components/others/spinnerTitle";
import SvgSave from "components/svg/SvgSave";
import * as apiObject from "api/apiObjects";
import { useToast } from "context/ToastContext";
import ETiny from "components/editors/ETiny";
import Editor from "components/editors/Editor";
import conf from "conf/conf";
  
const ObjectTabDescription = () => {
    const { t } = useTranslation(['Objects']);
    const { vObject, fetchObject, setShowSpinner, isEditLocked } = useObjectCard();
    const { showToast }  = useToast();
    const [isSaving, setIsSaving] = useState(false);
    const refEdit = useRef();
    const quillKey = useRef(`quill-descr-${Date.now()}`);
    const TinyEditor = (conf.tinyMode ? ETiny : Editor);

    const handleSave = async () => {
        console.log( refEdit.current?.editor?.getContent())
        const objectInfo = refEdit.current?.editor?.getContent()||''; //refEdit.current.getContent(); //refEdit?.current?.value != '<p><br></p>' ? refEdit?.current?.value|| '' : '';
        setIsSaving(true);
        setShowSpinner(true);
        const resInfo = await apiObject.setInfo(vObject.object.ID, objectInfo);
        await fetchObject();
        if (resInfo) showToast(t('messInfoSaved'), 'success')
            else showToast(t('common:messError'), 'danger');
        setIsSaving(false);
    }

    return (<>

        {!isEditLocked
        ?(<>
            <div className="px-2">
                <TinyEditor 
                    autoGrow
                    ref={refEdit}
                    defaultValue={vObject?.object.objectInfo||null}/>
            </div>
            
            <div className="pt-3 text-center">
                <Button onClick={handleSave}
                    disabled={isSaving}>
                    {spinnerTitle((<><SvgSave className="me-2 mtop-2"/>{t('common:buttons.save')}</>), 
                        isSaving, t('common:buttons.saving'))}
                </Button>
            </div></>)

        :(
            <div className="px-4" 
                dangerouslySetInnerHTML={{__html:vObject?.object.objectInfo||''}}></div>
        )}


    </>)
}

export default ObjectTabDescription;
 